// A batch expiry is a calendar day, the one printed on the vial, with no time and no time zone (CY-371).
// The column is a date: Zero reads it as the UTC midnight of that day (a number), Drizzle as 'YYYY-MM-DD'.
const DAY_MS = 86_400_000;
/** The UTC midnight of the calendar day a timestamp falls on in UTC, the value a batch expiry is stored as. */
export function utcDayOf(ms) {
    const date = new Date(ms);
    return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
}
/** Today's calendar day where the user is, as the same UTC-midnight value, so it compares with a batch expiry. */
export function todayAsUtcDay(now = new Date()) {
    return Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
}
/** A batch is usable through its expiry day and expired from the next day on. */
export function isBatchExpired(expiryDate, now = new Date()) {
    return utcDayOf(expiryDate) < todayAsUtcDay(now);
}
/** The last moment of the expiry day (UTC): what a preparation's use-by or a rest vial is capped at. */
export function endOfExpiryDay(expiryDate) {
    return utcDayOf(expiryDate) + DAY_MS - 1;
}
/** 'YYYY-MM-DD' of a batch expiry, for SQL against the date column. */
export function isoDayOf(expiryDate) {
    return new Date(utcDayOf(expiryDate)).toISOString().slice(0, 10);
}
//# sourceMappingURL=batch-expiry.js.map